import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { KtList3hktaavzmj137 as KtList } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractList() {
      constructor(list, fromIndex, toIndex) {
        return new.target.new_kotlin_collections_AbstractList_SubList_n10zp_k$(list, fromIndex, toIndex);
      }
      static new_kotlin_collections_AbstractList_SubList_n10zp_k$(list, fromIndex, toIndex) {
        var $this = this.new_kotlin_collections_AbstractList_ccp2qg_k$();
        $this.list_1 = list;
        $this.fromIndex_1 = fromIndex;
        $this._size_1 = 0;
        Companion_instance.checkRangeIndexes_mmy49x_k$($this.fromIndex_1, toIndex, $this.list_1.get_size_woubt6_k$());
        $this._size_1 = toIndex - $this.fromIndex_1 | 0;
        return $this;
      }
      get_c1px32_k$(index) {
        Companion_instance.checkElementIndex_s0yg86_k$(index, this._size_1);
        return this.list_1.get_c1px32_k$(this.fromIndex_1 + index | 0);
      }
      get_size_woubt6_k$() {
        return this._size_1;
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        Companion_instance.checkRangeIndexes_mmy49x_k$(fromIndex, toIndex, this._size_1);
        return SubList().new_kotlin_collections_AbstractList_SubList_n10zp_k$(this.list_1, this.fromIndex_1 + fromIndex | 0, this.fromIndex_1 + toIndex | 0);
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.$this_1 = $outer;
        this.index_1 = 0;
      }
      hasNext_bitz1p_k$() {
        return this.index_1 < this.$this_1.get_size_woubt6_k$();
      }
      next_20eer_k$() {
        if (!this.hasNext_bitz1p_k$())
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var _unary__edvuaz = this.index_1;
        this.index_1 = _unary__edvuaz + 1 | 0;
        return this.$this_1.get_c1px32_k$(_unary__edvuaz);
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_2 = $outer;
        super($outer, $box);
        Companion_instance.checkPositionIndex_w4k0on_k$(index, this.$this_2.get_size_woubt6_k$());
        this.index_1 = index;
      }
      hasPrevious_qh0629_k$() {
        return this.index_1 > 0;
      }
      previous_l2dfd5_k$() {
        if (!this.hasPrevious_qh0629_k$())
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        this.index_1 = this.index_1 - 1 | 0;
        return this.$this_2.get_c1px32_k$(this.index_1);
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.maxArraySize_1 = 2147483639;
      }
      checkElementIndex_s0yg86_k$(index, size) {
        if (index < 0 || index >= size) {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('index: ' + index + ', size: ' + size);
        }
      }
      checkPositionIndex_w4k0on_k$(index, size) {
        if (index < 0 || index > size) {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('index: ' + index + ', size: ' + size);
        }
      }
      checkRangeIndexes_mmy49x_k$(fromIndex, toIndex, size) {
        if (fromIndex < 0 || toIndex > size) {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
        }
        if (fromIndex > toIndex) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
        }
      }
      checkBoundsIndexes_tsopv1_k$(startIndex, endIndex, size) {
        if (startIndex < 0 || endIndex > size) {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size);
        }
        if (startIndex > endIndex) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
        }
      }
      newCapacity_k5ozfy_k$(oldCapacity, minCapacity) {
        var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
        if ((newCapacity - minCapacity | 0) < 0)
          newCapacity = minCapacity;
        if ((newCapacity - 2147483639 | 0) > 0)
          newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
        return newCapacity;
      }
      orderedHashCode_srkix_k$(c) {
        var hashCode_0 = 1;
        var _iterator__ex2g4s = c.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var e = _iterator__ex2g4s.next_20eer_k$();
          var tmp = imul(31, hashCode_0);
          var tmp1_elvis_lhs = e == null ? null : hashCode(e);
          hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        return hashCode_0;
      }
      orderedEquals_jt170c_k$(c, other) {
        if (!(c.get_size_woubt6_k$() === other.get_size_woubt6_k$()))
          return false;
        var otherIterator = other.iterator_jk1svi_k$();
        var _iterator__ex2g4s = c.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var elem = _iterator__ex2g4s.next_20eer_k$();
          var elemOther = otherIterator.next_20eer_k$();
          if (!equals(elem, elemOther)) {
            return false;
          }
        }
        return true;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractListClass;
function AbstractList() {
  if (AbstractListClass === VOID) {
    class $ extends AbstractCollection() {
      static new_kotlin_collections_AbstractList_ccp2qg_k$() {
        return this.new_kotlin_collections_AbstractCollection_s1tlv0_k$();
      }
      iterator_jk1svi_k$() {
        return new (IteratorImpl())(this);
      }
      indexOf_si1fv9_k$(element) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            if (equals(item, element)) {
              tmp$ret$0 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$0 = -1;
        }
        return tmp$ret$0;
      }
      listIterator_70e65o_k$(index) {
        return new (ListIteratorImpl())(this, index);
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        return SubList().new_kotlin_collections_AbstractList_SubList_n10zp_k$(this, fromIndex, toIndex);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.orderedEquals_jt170c_k$(this, other);
      }
      hashCode() {
        return Companion_instance.orderedHashCode_srkix_k$(this);
      }
    }
    initMetadataForClass($, 'AbstractList', VOID, VOID, [KtList()]);
    AbstractListClass = $;
  }
  return AbstractListClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance2ztfx9zvq7j5d,
  AbstractList as AbstractList3ck35puwbp1e9,
};
//endregion

//# sourceMappingURL=AbstractList.mjs.map
